let Admin = {
  themes: {
    default: { class: "bg-admin-default", color: '#818cf8', permission: 'administrador' },
    gerente: { class: "bg-admin-gerente", color: '#38bdf8', permission: 'gerente' },
    logistica: { class: "bg-admin-logistica", color: '#60a5fa', permission: 'logistica' },
    supervisor: { class: "bg-admin-vendedor", color: `${process.env.REACT_APP_SELLER_COLOR}`, permission: 'supervisor' },
    vendedor: { class: "bg-admin-vendedor", color: `${process.env.REACT_APP_SELLER_COLOR}`, permission: 'operacao' },
    operacao: { class: "bg-admin-default", color: `${process.env.REACT_APP_SELLER_COLOR}`, permission: 'operacao' },
    parceiro: { class: "bg-admin-vendedor", color: `${process.env.REACT_APP_SELLER_COLOR}`, permission: 'parceiro' },
    atendente: { class: "bg-admin-default", color: `${process.env.REACT_APP_SELLER_COLOR}`, permission: 'atendente' },

  },

  items: [
    {
      section: "Geral",
      options: [
        {
          icon: "dashboard",
          text: "Dashboard",
          link: "/admin",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'parceiro', 'supervisor'],
        },
        {
          icon: "people",
          text: "Clientes",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'supervisor'],
        },
        {
          icon: "shopping_cart",
          text: "Reservas",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'parceiro', 'supervisor'],
        },
        {
          icon: "receipt_long",
          text: "Orçamentos",
          permission: ['administrador', 'gerente', 'operacao', 'supervisor'],
        },
        {
          icon: "calendar_today",
          text: "Cupos",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'supervisor', 'atendente'],
          
        },
        {
          icon: "departure_board",
          text: "Saídas",
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          icon: "payments",
          text: "Pagamentos",
          link: "/admin/pagamentos",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'supervisor'],
        },
        {
          // Subiu de "Administrar" pra "Geral" (2026-08-13) — leitura ampliada pra todo
          // consultor ativo (vê se foi pedido, se foi aprovado, baixa o comprovante), mas
          // só das PRÓPRIAS vendas (escopo aplicado no backend, RefundController::index).
          // Liberar/Recusar continuam exclusivos de marcelo@/logistica@ (escondido no front).
          icon: "replay",
          text: "Reembolsos",
          link: "/admin/reembolsos",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'supervisor'],
        },
        {
          // Resumo 7/15/30 dias de liberações de cartão, antifraude e chargebacks (2026-10-20).
          // Só gestão — o backend (PaymentSecurityController) também barra os demais perfis.
          icon: "verified_user",
          text: "Segurança dos pagamentos",
          link: "/admin/seguranca-pagamentos",
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          // Feature "Revisão de vendas" (2026-08-17): mesmo relatório de comissão
          // que já existe em Relatórios > Comissões, mas self-service — o próprio
          // vendedor entra e vê só os PRÓPRIOS números, já com o mês atual
          // selecionado (escopo aplicado no backend, CommissionController::sales
          // e SellerController::findSeller — ignora id da URL pra quem não é
          // administrador/gerente e força o próprio typeable_id).
          icon: "percent",
          text: "Revisão de vendas",
          link: "/admin/revisao-vendas",
          permission: ['administrador', 'gerente', 'operacao', 'supervisor', 'parceiro'],
        },
        {
          // Feature "Consulta de custos operacionais" (2026-08-19): tela de
          // LEITURA pra qualquer role conferir o custo operacional (grupo ou
          // privado) de um passeio antes de vender — nasceu do bug de custo
          // de passeio privado (ver bug_custo_operacional_privado_multiplicado.md).
          // Sem restrição de perfil de propósito — todo mundo que vende
          // precisa poder consultar.
          icon: "manage_search",
          text: "Custos operacionais",
          link: "/admin/custos-operacionais",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'supervisor', 'parceiro', 'atendente'],
        },
      ]
    },
    {
      section: "Administrar",
      permission: ['administrador', 'gerente', 'logistica'],
      options: [
        {
          icon: "account_balance",
          text: "Contas Asaas",
          link: "/admin/contas-asaas",
          permission: ['administrador'],
        },
        {
          icon: "monetization_on_icon",
          text: "Fluxo de Caixa",
          permission: ['administrador', 'gerente'],
        },
        {
          icon: "pending_actions",
          text: "Aprovações",
          permission: ['administrador'],
        },
        {
          id: "central",
          icon: "chat",
          text: "Central",
          dropdown: true,
          children: [
            {
              name: 'Mensagens',
            },
            {
              name: 'Templates',
            },
            {
              name: 'Tipos',
            }
          ],
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          icon: "map",
          text: "Regiões",
          permission: ['administrador', 'gerente'],
        },
        {
          icon: "photo_camera",
          text: "Passeios",
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          icon: "flight",
          text: "Traslados",
          permission: ['administrador', 'gerente'],
        },
        {
          icon: "card_travel",
          text: "Combos",
          permission: ['administrador', 'gerente'],
        },
        {
          icon: 'directions_bus_filled',
          text: 'Veículos',
          permission: ['administrador', 'gerente'],
        },
        {
          icon: "storefront",
          text: "Vendedores",
          permission: ['administrador', 'gerente'],
        },
        {
          icon: "accessibility",
          text: "Motoristas",
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          icon: "person_search",
          text: "Guias",
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          id: "partners",
          icon: "assignment_ind",
          text: "Parceiros",
          dropdown: true,
          children: [
            {
              name: 'Agências',
            },
            {
              name: 'Vendedores',
            }
          ],
          permission: ['administrador', 'gerente'],
        },
      ]
    },
    {
      section: "Relatórios",
      permission: ['administrador', 'gerente'],
      options: [
        {
          icon: "percent",
          text: "Comissões",
        },
      ]
    },
    {
      section: "Suporte",
      options: [
        {
          icon: "confirmation_number",
          text: "Tickets",
          link: "/admin/tickets",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'supervisor', 'vendedor', 'atendente'],
        },
        {
          icon: "star",
          text: "CSAT Interno",
          link: "/admin/tickets/csat",
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          icon: "emoji_emotions",
          text: "CSAT Viagem",
          link: "/admin/csat-viagem",
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          icon: "campaign",
          text: "Broadcast App",
          link: "/admin/broadcast-app",
          permission: ['administrador', 'gerente'],
        },
        {
          icon: "local_offer",
          text: "Promoções FT App",
          link: "/admin/promo-app",
          permission: ['administrador', 'gerente'],
        },
      ]
    }
  ]
};

export default Admin;